import {postMessageToParent} from "../lookMessaging";
import {GROHE_POST_MESSAGES_ACTIONS} from "../iframeIntegration";

const WithOpenMiniCartPostMessage = (props) => {

  const {children} = props;

  const openMiniCartPostMessage = () => {
    postMessageToParent({
      "EventType": GROHE_POST_MESSAGES_ACTIONS.openMiniCart,
      "cartFlag": true,
    });
  }

  return children(openMiniCartPostMessage)
};

export default WithOpenMiniCartPostMessage
